import React, { FC, memo } from 'react';
import LinkageEmptyIcon from '@/pages/aigc/assets/svg/agent-linkaget-emtey.svg';
import './index.scss';

export interface ISkillDetailEmptyStateProps {
  /** 空态文案 */
  message: string;
  /** 外层修饰类名 */
  className?: string;
}

const PREFIX = 'dba-skill-detail-empty';

/**
 * Skill 详情页空态（联动案例无内容 / Skill 未找到等复用）
 */
const SkillDetailEmptyState: FC<ISkillDetailEmptyStateProps> = ({
  message,
  className,
}) => (
  <div className={[PREFIX, className].filter(Boolean).join(' ')}>
    <img
      src={LinkageEmptyIcon}
      alt=""
      className={`${PREFIX}__icon`}
      aria-hidden
    />
    <p className={`${PREFIX}__text`}>{message}</p>
  </div>
);

export default memo(SkillDetailEmptyState);
